import React from 'react'
import { CheckMarkIcon } from '@mote/assets/icons'
import type { CommonButtonProps } from './Common'
import { CommonButton } from './Common'

export interface CompleteButtonProps
  extends Pick<CommonButtonProps, 'onClick'> {}

export function CompleteButton(props: CompleteButtonProps): JSX.Element {
  return (
    <CommonButton
      variant={'primary'}
      size={'m'}
      id={'complete-button'}
      text={'Complete'}
      onClick={props.onClick}
      ariaLabel={'complete'}
    >
      <CheckMarkIcon width={'48px'} height={'48px'} />
    </CommonButton>
  )
}
